<div class="container">
    <table class="table tabl-sm">
        <thead>
        <tr>
            <th>Account ID</th>
            <th>Merchant Name</th>
            <th>Invalid Message(s)</th>
            <th></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let merchantAccount of merchantAccounts">
            <td>{{merchantAccount.id}}</td>
            <td>{{merchantAccount.preferredMerchantName}}</td>
            <td>
                <p *ngFor="let invalidMessage of merchantAccount.invalidMessages">
                    {{invalidMessage}}
                </p>
            </td>
            <td>
                <a [routerLink]="['/account', merchantAccount.id]" title="Edit Merchant Account" class="btn btn-uiowa-dark btn-sm">
                    <fa-icon [icon]="['fas', 'edit']"></fa-icon>
                </a>
            </td>
        </tr>
        </tbody>
    </table>
</div>
